export default __webpack_public_path__ + "8771894959de6e640354fc687099d82d.ttf";